import { render } from "./hr-au-rtw.vue?vue&type=template&id=4227ca5c"
import script from "./hr-au-rtw.vue?vue&type=script&lang=js"
export * from "./hr-au-rtw.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__